import React from 'react'

const Checkout = () => <div>Página checkout</div>

export default Checkout
